import * as axios from 'axios';

var instance = axios.create();
// instance.defaults.baseURL = serverURL;
// instance.defaults.timeout = 20000;
instance.interceptors.request.use(request => {
    // console.log('Starting Request', request)
    return request
})
export { instance as default };